export const NUMBER_OF_ROWS_FOR_TEXTAREA = 5;
export const ACTUAL_LANDING_PAGE = '/media';
/**
 * Using this to get the full list of companies/series/experts
 * that the CMS user can browse to get the entity they want.
 * The entity list gets filtered as the user types more characters
 */
export const MAX_NUMBER_OF_ENTITIES = 9999;
